import { Group, Text } from "@mantine/core";
import { formatCents } from "../../utils/amount";

export function InvoiceBreakdown({
  lines,
  discount,
  tax,
  currency,
}: {
  lines: {
    description: string | null;
    amount: number;
    quantity: number | null;
  }[];
  discount: number;
  tax: number;
  currency: string;
}) {
  return (
    <>
      {/** A tier's flat fee comes back with no quantity, the units it covers are their own line. */}
      {lines
        .filter((line) => line.amount !== 0 || line.quantity)
        .map((line, index) => (
          <Group
            key={index}
            justify="space-between"
            align="baseline"
            wrap="nowrap"
          >
            <Text size="sm" c="dimmed">
              {line.description}
            </Text>
            <Text size="sm">{formatCents(line.amount, currency)}</Text>
          </Group>
        ))}

      {!!discount && (
        <Group justify="space-between" align="baseline">
          <Text size="sm" c="dimmed">
            Discount
          </Text>
          <Text size="sm">-{formatCents(discount, currency)}</Text>
        </Group>
      )}

      {!!tax && (
        <Group justify="space-between" align="baseline">
          <Text size="sm" c="dimmed">
            Tax
          </Text>
          <Text size="sm">{formatCents(tax, currency)}</Text>
        </Group>
      )}
    </>
  );
}
